import { render, staticRenderFns } from "./LeftColumn.vue?vue&type=template&id=1c6d7489&scoped=true&"
import script from "./LeftColumn.vue?vue&type=script&lang=js&"
export * from "./LeftColumn.vue?vue&type=script&lang=js&"
import style0 from "./LeftColumn.vue?vue&type=style&index=0&id=1c6d7489&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6d7489",
  null
  
)

export default component.exports